<template>
  <div style="text-align: left">
    <div style="margin-bottom: 10px">
      <el-button type="primary" class="add" size="small" @click="addPlayer">
        <i class="el-icon-plus"></i>
        新增选手
      </el-button>
      <el-button type="primary" class="add" size="small" @click="upload">
        <i class="el-icon-upload"></i>
        导入选手
      </el-button>
      <el-button type="danger" size="small" class="delete" @click="delMulData">
        <i class="el-icon-delete"></i>删除
      </el-button>
    </div>
    <div>
      <div class="box">
        <el-form :inline="true" size="mini">
          <el-form-item>
            <el-input
              placeholder="请输入选手姓名"
              clearable
              v-model="searchForm.name"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-input
              placeholder="请输入选手身份证号"
              clearable
              v-model="searchForm.identityNo"
            ></el-input>
          </el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="doSearch"
            class="queryBtn"
            >查询</el-button
          >
        </el-form>
      </div>
    </div>
    <el-table
      ref="multipleTable"
      :data="tableListData"
      tooltip-effect="dark"
      style="width: 100%; position: relative"
      :row-class-name="tableRowClassName"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        type="selection"
        min-width="40"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="姓名"
      ></el-table-column>
      <el-table-column
        prop="sex"
        align="center"
        label="性别"
        width="80"
        :formatter="sexFormatter"
      ></el-table-column>
      <el-table-column
        prop="birthday"
        :formatter="birthdayFormat"
        align="center"
        label="出生日期"
      ></el-table-column>
      <el-table-column
        prop="identityNo"
        align="center"
        label="证件号"
      ></el-table-column>
      <el-table-column
        prop="teamName"
        align="center"
        label="代表队"
      ></el-table-column>
      <!--<el-table-column
        prop="teamClassName"
        align="center"
        label="分类"
      ></el-table-column>-->
      <el-table-column
        prop="isIdentityValidated"
        align="center"
        label="实名认证"
      >
        <template slot-scope="scope">
          <span v-if="scope.row.isIdentityValidated">已认证</span>
          <el-button
            v-if="!scope.row.isIdentityValidated"
            @click="identityValidate(scope.row)"
            type="text"
            >去认证</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        prop="operation"
        label="操作"
        width="100"
        fixed="right"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            @click="deletePlayer(scope.row)"
            class="btnopt"
            size="small"
            >删除</el-button
          >
          <el-button
            type="text"
            size="small"
            @click="editPlayer(scope.row)"
            class="btnopt"
            >编辑</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="paging">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="searchForm.page"
        :page-sizes="[15, 20, 50, 100]"
        :page-size="searchForm.pageSize"
        background
        layout="prev, pager, next,total, sizes, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <!--新增弹框-->
    <el-dialog
      :title="formTitle"
      :inline="true"
      :visible.sync="dialogFormVisible"
    >
      <el-form
        :model="form"
        label-position="right"
        label-width="110px"
        :rules="formRules"
        ref="form"
      >
        <el-form-item label="所属代表队" prop="teamId">
          <el-select v-model="form.teamId">
            <el-option
              v-for="item in teamoptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="identityType">
          <el-radio-group v-model="form.identityType">
            <el-radio :label="1">身份证</el-radio>
            <el-radio :label="2">户口</el-radio></el-radio-group
          >
        </el-form-item>
        <el-form-item label="证件号码" prop="identityNo">
          <el-input v-model="form.identityNo" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="性别" prop="sex">
          <el-radio v-model="form.sex" :label="1">男</el-radio>
          <el-radio v-model="form.sex" :label="2">女</el-radio>
        </el-form-item>
        <el-form-item label="出生日期" prop="birthday">
          <el-date-picker
            v-model="form.birthday"
            type="date"
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="'实名认证'"
      :inline="true"
      :visible.sync="dialogValidateFormVisible"
    >
      <el-form
        :model="formIdentity"
        label-position="right"
        label-width="110px"
        :rules="formIdentityRules"
        ref="formIdentity"
      >
        <el-form-item label="姓名" prop="name">
          <el-input v-model="formIdentity.name" maxlength="255"></el-input>
        </el-form-item>
        <el-form-item label="证件类型" prop="identityType">
          <el-radio-group v-model="formIdentity.identityType">
            <el-radio :label="1">身份证</el-radio>
            <el-radio :label="2">护照/其它</el-radio></el-radio-group
          >
        </el-form-item>
        <el-form-item label="证件号码" prop="identityNo">
          <el-input
            v-model="formIdentity.identityNo"
            maxlength="255"
          ></el-input>
        </el-form-item>
        <el-form-item prop="fileurl">
          <el-upload
            v-if="formIdentity.identityType == 2"
            ref="upload"
            action=""
            accept="image/png,image/gif,image/jpg,image/jpeg"
            :limit="1"
            :http-request="uploadEditFile"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传jpg/png文件，且不超过500kb
            </div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div>年龄小于7岁需要实名认证请上传户口拍照图片认证</div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogValidateFormVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="submitFormIdentity"
          :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :title="'导入选手'"
      :inline="true"
      :visible.sync="dialogImportVisible"
    >
      <el-form
        :model="importForm"
        label-position="right"
        label-width="110px"
        :rules="importFormRules"
        ref="importForm"
      >
        <el-form-item label="代表队" prop="teamId">
          <el-select v-model="importForm.teamId" clearable>
            <el-option
              v-for="item in teamoptions"
              :value="item.value"
              :label="item.name"
              :key="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选手信息" prop="player">
          <el-upload
            ref="uploader"
            class="upload"
            action=""
            :auto-upload="false"
            accept=".csv,.xls,.xlsx"
            :http-request="uploadFile"
            :limit="1"
          >
            <el-button size="small" type="primary">点击上传</el-button>
            <div slot="tip" class="el-upload__tip">只能上传Excel文件</div>
          </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogImportVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitImport" :loading="isLoading"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import API from "../apis/player";
import moment from "moment";
import TAPI from "../apis/userteam";
export default {
  data() {
    return {
      formTitle: "",
      isLoading: false,
      dialogValidateFormVisible: false,
      dialogFormVisible: false,
      dialogImportVisible: false,
      multipleSelection: [],
      teamoptions: [],
      total: 0,
      teamClassOptions: [],
      tableListData: [],
      searchForm: {
        name: null,
        page: 1,
        pageSize: 15,
      },
      form: {
        id: 0,
        teamClassId: null,
        name: "",
        identityType: 1,
        identityNo: null,
        sex: null,
        birthday: null,
        teamId: null,
      },
      formIdentity: {
        id: 0,
        name: "",
        identityNo: null,
        identityType: 2,
        fileurl: null,
      },
      importForm: {
        teamId: null,
        player: null,
      },
      formIdentityRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        identityNo: [{ validator: this.validID2, trigger: "blur" }],
        fileurl: [
          {
            required: true,
            message: "请选择护照文件",
            validator: this.validatePassport,
            trigger: "change",
          },
        ],
      },
      importFormRules: {
        teamId: [{ required: true, message: "请选择代表队", trigger: "blur" }],
        player: [
          {
            required: true,
            message: "请选择选手文件",
            trigger: "change",
            validator: this.validateFile,
          },
        ],
      },
      formRules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        identityType: [
          { required: true, message: "请选择证件类型", trigger: "blur" },
        ],
        sex: [{ required: true, message: "请选择性别", trigger: "blur" }],
        identityNo: [{ validator: this.validID, trigger: "blur" }],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    async validatePassport (rule, value, callback) {
      if (this.formIdentity.identityType == 2) {       
        if (value!=null&&value!='') {
          callback()
        } else {
          callback(new Error('请上传护照'))
        }
      } else {
        callback()
      }
    },
    validateFile: function (rule, value, callback) {
      if (!this.$refs.uploader.uploadFiles.length) {
        callback(new Error("请选择要上传的文件"));
      } else {
        var regx = new RegExp("(.xlsx)$|(.cvs)$|(.txt)$|(.xls)$");
        if (
          !regx.test(
            this.$refs.uploader.uploadFiles[
              this.$refs.uploader.uploadFiles.length - 1
            ].name
          )
        ) {
          callback(new Error("文件格式只支持xlsx、cvs、txt、xls"));
        }
        callback();
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "warning-row";
      } else {
        return "success-row";
      }
    },
    upload() {
      this.dialogImportVisible = true;
      this.$nextTick(() => {
        this.$refs["importForm"].resetFields();
        this.$refs["uploader"].clearFiles();
        if (this.teamoptions.length > 0) {
          this.importForm.teamId = this.teamoptions[0].value;
        }
      });
    },
    submitImport() {
      this.isLoading = true;
      this.$refs.importForm.validate((valid) => {
        if (valid) {
          this.$refs.uploader.submit();
        } else {
          this.isLoading = false;
        }
      });
    },
    uploadFile(item) {
      const form = new FormData();
      form.append("file1", item.file);
      form.append("teamId", this.importForm.teamId);
      API.import(form)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "导入成功!",
            });
            this.search();
            this.dialogImportVisible = false;
            this.isLoading = false;
          } else {
            this.$message({
              type: "error",
              message: data.message,
            });
            this.isLoading = false;
          }
        })
        .catch((err) => {});
    },
    uploadEditFile: function (param) {
      this.uploading = true;
      var fileObj = param.file;
      var form = new FormData();
      form.append("file", fileObj);
      var that = this;
      API.upload(form)
        .then((result) => {
          if (result.code == 0) {
            that.$message.success({
              showClose: true,
              message: "上传成功",
              duration: 2000,
            });
            that.formIdentity.fileurl = result.result;
          } else {
            that.$message.error({
              showClose: true,
              message: "上传失败",
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          that.$message.error({
            showClose: true,
            message: "请求异常",
            duration: 2000,
          });
        });
    },
    beforeupload(file) {
      this.formIdentity.file = file;
      return false;
    },
    identityValidate(row) {
      this.dialogValidateFormVisible = true;
      this.formIdentity.id = row.id;
      this.formIdentity.name = row.name;
      this.formIdentity.identityType = row.identityType;
      this.formIdentity.identityNo = row.identityNo;
    },
    submitFormIdentity() {
      let that = this;
      this.isLoading = true;
      this.$refs.formIdentity.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.formIdentity);
          if (params.identityType == 2) {
            API.validateHouseHold(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "认证成功",
                      duration: 2000,
                    });
                    that.dialogValidateFormVisible = false;
                    that.$refs["formIdentity"].resetFields();
                    that.search();
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: data.message,
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          } else {
            API.validate(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "认证成功",
                      duration: 2000,
                    });
                    that.dialogValidateFormVisible = false;
                    that.$refs["formIdentity"].resetFields();
                    that.search();
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: data.message,
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          }
        } else {
          that.isLoading = false;
        }
      });
    },
    birthdayFormat: function (row, column) {
      var date = row.birthday;
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD");
    },
    async validID2(rule, value, callback) {
      if (this.formIdentity.identityType == 1) {
        let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if (reg.test(value)) {
          callback();
        } else {
          callback(new Error("身份证号码不正确"));
        }
      } else {
        callback();
      }
    },
    async validID(rule, value, callback) {
      let reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      if (this.form.identityType == 1) {
        if (reg.test(value)) {
          await this.go(value.length);
          callback();
        } else {
          callback(new Error("身份证号码不正确"));
        }
      } else {
        callback();
      }
    },

    go(val) {
      let iden = this.form.identityNo;
      let sex = null;
      let birth = null;
      if (val === 18) {
        sex = iden.substring(16, 17);
        birth =
          iden.substring(6, 10) +
          "-" +
          iden.substring(10, 12) +
          "-" +
          iden.substring(12, 14);
      }
      if (val === 15) {
        sex = iden.substring(13, 14);
        birth =
          "19" +
          iden.substring(6, 8) +
          "-" +
          iden.substring(8, 10) +
          "-" +
          iden.substring(10, 12);
      }
      if (sex % 2 === 0) sex = 2;
      else sex = 1;
      this.form.sex = sex;
      this.form.birthday = birth;
    },
    sexFormatter(row, column) {
      return row.sex == 1 ? "男" : "女";
    },
    editPlayer(row) {
      this.formTitle = "编辑选手";
      API.get({ id: row.id }).then((result) => {
        this.dialogFormVisible = true;
        this.form = Object.assign({}, result.result);
        if (this.form.teamClassId == 0) {
          this.form.teamClassId = null;
        }
        this.form.teamId = this.form.teamId.toString();
      });
    },
    addPlayer() {
      this.formTitle = "新增选手";
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.form.id = 0;
        this.$refs["form"].resetFields();
        if (this.teamoptions != null && this.teamoptions.length > 0) {
          this.form.teamId = this.teamoptions[0].value;
        }
      });
    },
    handleSizeChange: function (val) {
      this.searchForm.pageSize = val;
      this.search();
    },
    handleCurrentChange: function (val) {
      this.searchForm.page = val;
      this.search();
    },
    doSearch() {
      this.searchForm.page = 1;
      this.search();
    },
    search: function () {
      let params = Object.assign({}, this.searchForm);
      API.getList(params)
        .then((result) => {
          if (result && result.code == 0) {
            this.tableListData = result.result.data;
            this.total = result.result.recordCount;
          } else {
            this.$message.error({
              showClose: true,
              message: result.result.message,
              duration: 2000,
            });
          }
        })
        .catch((error) => {
          this.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    submitForm() {
      let that = this;
      this.isLoading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.form);
          if (params.teamClassId == null) {
            params.teamClassId = 0;
          }
          if (params.id > 0) {
            API.edit(params)
              .then(
                (data) => {
                  if (data.code == 0) {
                    that.$message.success({
                      showClose: true,
                      message: "更改成功",
                      duration: 2000,
                    });
                    that.dialogFormVisible = false;
                    that.$refs["form"].resetFields();
                    that.search();
                  } else {
                    this.$message.error({
                      showClose: true,
                      message: data.message,
                      duration: 2000,
                    });
                  }
                  that.isLoading = false;
                },
                function (err) {
                  that.$message.error({
                    showClose: true,
                    message: err.toString(),
                    duration: 2000,
                  });
                  that.isLoading = false;
                }
              )
              .catch(function (error) {
                that.$message.error({
                  showClose: true,
                  message: "请求出现异常",
                  duration: 2000,
                });
                that.isLoading = false;
              });
          } else {
            API.add(params)
              .then((result) => {
                if (result.code == 0) {
                  this.$message.success({
                    showClose: true,
                    message: "新增成功",
                    duration: 2000,
                  });
                  this.$refs["form"].resetFields();
                  this.dialogFormVisible = false;
                  this.search();
                  this.isLoading = false;
                } else {
                  this.$message.error({
                    showClose: true,
                    message: result.message,
                    duration: 2000,
                  });
                  this.isLoading = false;
                }
              })
              .catch((error) => {
                this.$message.error({
                  showClose: true,
                  message: "请求异常",
                  duration: 2000,
                });
                this.isLoading = false;
              });
          }
        } else {
          this.isLoading = false;
        }
      });
    },
    deletePlayer(row) {
      let params = { id: row.id };
      this.$confirm("确认删除记录吗？", "提示", { type: "warning" })
        .then(() => {
          API.delete(params)
            .then((result) => {
              console.log(result);
              if (result.code == 0) {
                this.$message.success({
                  showClose: true,
                  message: "删除成功",
                  duration: 2000,
                });
                this.search();
              } else {
                this.$message.error({
                  showClose: true,
                  message: data.message,
                  duration: 2000,
                });
              }
            })
            .catch((error) => {
              this.$message.error({
                showClose: true,
                message: "",
                duration: 2000,
              });
            });
        })
        .catch(() => {});
    },
    /*批量删除*/
    delMulData() {
      let that = this;
      let val = that.multipleSelection;
      let idArray = [];
      for (var i = 0; i < val.length; i++) {
        idArray.push(val[i].id);
      }
      this.$confirm("此操作将永久删除该数据，是否继续？", "提示", {
        confimButtonTexe: "确定",
        cancelButtonTexe: "取消",
        type: "warning",
      }).then(() => {
        if (idArray) {
          API.deleteBatch({ ids: idArray.join() })
            .then(
              function (result) {
                that.loading = false;
                if (result && result.code == 0) {
                  that.$message.success({
                    showClose: true,
                    message: "删除成功",
                    duration: 2000,
                  });
                  that.search();
                } else {
                  that.$message.error({
                    showClose: true,
                    message: data.message,
                    duration: 2000,
                  });
                }
              },
              function (err) {
                that.loading = false;
                that.$message.error({
                  showClose: true,
                  message: err.toString(),
                  duration: 2000,
                });
              }
            )
            .catch(function (error) {
              that.loading = false;
              console.log(error);
              that.$message.error({
                showClose: true,
                message: "请求出现异常",
                duration: 2000,
              });
            });
        }
      });
      this.$refs.multipleTable.clearSelection();
    },
  },
  computed: {},
  mounted() {
    this.search();
    /*TCAPI.select().then(res => {
      this.teamClassOptions = res.result;
    });*/
    TAPI.select().then((res) => {
      this.teamoptions = res.result;
    });
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/TeamPlayer.vue